import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const items = [['S.M.', 'Dance Fitness Instructor — London, UK', 'I used to spend my Sunday evenings building routines from scratch. Now I open the system, pick the class, and walk in completely ready.'], ['C.V.', 'Dance Fitness Instructor — Toronto, Canada', 'The 50 ready-to-teach lesson plans alone saved me more hours than I can count in my first month.'], ['J.R.', 'Dance Fitness Instructor — Sydney, Australia', 'The choreography combinations completely changed the way I build my classes. My sessions feel more professional and students keep coming back.']];
export function TestimonialsStrip() {
  return <section className="bg-cloud px-4 py-12" data-id="element-208">
      <div className="mx-auto grid max-w-7xl gap-5 md:grid-cols-3" data-id="element-209">
        {items.map(([name, role, quote], index) => <motion.figure key={name} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.06
      }} className="rounded-2xl border border-line bg-white p-6 shadow-sm" data-id="element-210">
            <div className="mb-4 flex gap-1 text-violet" data-id="element-211">
              {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} size={15} fill="currentColor" data-id="element-212" />)}
            </div>
            <blockquote className="text-sm italic leading-relaxed text-slate-600" data-id="element-213">
              “{quote}”
            </blockquote>
            <figcaption className="mt-5 flex items-center gap-3" data-id="element-214">
              <span className="flex size-9 items-center justify-center rounded-full bg-navy text-xs font-bold text-white" data-id="element-215">
                {name}
              </span>
              <span className="text-xs text-navy-light" data-id="element-216">{role}</span>
            </figcaption>
          </motion.figure>)}
      </div>
    </section>;
}